import { render, staticRenderFns } from "./expHeader.vue?vue&type=template&id=70583fca&scoped=true&"
import script from "./expHeader.vue?vue&type=script&lang=js&"
export * from "./expHeader.vue?vue&type=script&lang=js&"
import style0 from "./expHeader.vue?vue&type=style&index=0&id=70583fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70583fca",
  null
  
)

export default component.exports